import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ApiService } from '../../../../api/api.service';
import { LoaderService } from '../../../../api/loader.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { ref, child, set } from 'firebase/database';

@Component({
    selector: 'app-asign-user-provider',
    templateUrl: './asign-user-provider.component.html',
    styleUrls: ['./asign-user-provider.component.css'],
    standalone: false
})
export class AsignUserProviderComponent implements OnInit {

  @Input() user_providers: EventEmitter<any>;
  @Input() provider_app: EventEmitter<any>;
  @Input() case_id: EventEmitter<number>;
  @Input() is_reassign: boolean;
  @Input() isNormalCase: boolean;
  @Input() is_visible: boolean;
  @Input() is_confirmation_visible: boolean;
  @Input() showEstimatedTime: boolean;
  @Input() last_provider_id: number;

  @Output() done = new EventEmitter<boolean>();
  @Output() reassign = new EventEmitter<any>();
  @Output() closeconfirm = new EventEmitter<boolean>();

  providers = null;
  selectedRow:number = null;
  provider:any = null;
  comment="";
  time_estimated:any = null;
  isDisabled = true;
  selected_provider_national_id: number=null;
  selected_case_id: number = null;
  fieldsRequired = {
    'select-provider-user':false,
  };
  db: any;

  provider_selected = null;

  constructor(
    private api: ApiService, 
    private LoaderService: LoaderService,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {
    this.user_providers.subscribe(providers =>{
      console.log(providers)
      this.providers = providers
    })
    this.case_id.subscribe(case_id =>{
      this.selected_case_id = case_id
    })
    this.db = this.firebaseService.db;

    if (this.provider_app) {
      this.provider_app.subscribe(provider_app =>{
        this.provider_selected = provider_app;
      });
    }
  }

  resetSelection(){
    this.done.emit(false);
    this.selectedRow = null;
    this.provider = null;
    this.providers = []
    this.comment = "";
    this.time_estimated = null;
    this.isDisabled=true;
  }

  setClickedRow(index, provider){
    this.selectedRow = index;
    this.provider = provider;
    this.selected_provider_national_id = provider.national_id;
    this.isDisabled = false;
  }

  onConfirm() {
    if (this.provider.assigned_cases > 0) {
      this.closeDisclosure(false);
    } else {
      this.onSubmit();
    }
  }

  onSubmit(){
    this.LoaderService.display(true);
    
    type DataType = {
      case_id: number;
      national_id: number;
      provider_id: number;
      operator: number;
      comment: string;
      normal_case?: boolean;
      time_estimated?: number
      provider_site_id?: number
      coverage_id?: number
      provider_selected_id?: number

    };
    
    let data: DataType = {
      "case_id":this.selected_case_id,
      "national_id":this.selected_provider_national_id,
      "provider_id": this.provider.id,
      "operator": 1,
      "comment":this.comment,
      "time_estimated": this.time_estimated,
      "provider_site_id": this.provider_selected?.provider_site_id || null,
      "coverage_id": this.provider_selected?.coverage_id || null,
      "provider_selected_id": this.provider_selected?.provider_id || null,

    }

    if (this.isNormalCase) {
      data.normal_case = true;
    }

    type HuaweiCase = {
      case: number;
      provider: number;
    };
    
    let huaweiCase: HuaweiCase = {
      "case":this.selected_case_id,
      "provider":this.selected_provider_national_id,
    }
    if (!this.is_reassign) {
      this.api.assistanceApp.assignProvider(data).promise().then(resp =>{
        this.statusAssignProvider(data, this.is_reassign);
        this.huaweiStatusAssignProvider(huaweiCase);
      })
    } else {
      this.api.assistanceApp.reassignProvider(data).promise()
        .then(rsp => {
          this.statusAssignProvider(data, this.is_reassign);
          this.huaweiStatusAssignProvider(huaweiCase);
        })
      this.reassign.emit(data);
    }
    
  }

  async statusAssignProvider(data, isReasign) {
    const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
    const childAssistanceCasesClient = child(dbRefAssistanceCases, data.case_id.toString());
    set(childAssistanceCasesClient, {
      'provider': data.provider_id,
      'status': 1,
    },);
    const childAssistanceCasesProvider = child(dbRefAssistanceCases, data.provider_id.toString());
    set(childAssistanceCasesProvider, {
      'provider': data.provider_id,
      'status': 1,
    },);
    if (isReasign) {
      const childAssistanceCasesLastProvider = child(dbRefAssistanceCases, this.last_provider_id.toString());
      set(childAssistanceCasesLastProvider, {
        'provider': this.last_provider_id,
        'status': 0,
      },);
    }
  }

  closeDisclosure(close: boolean) {
    this.closeconfirm.emit(close)
  }

  async huaweiStatusAssignProvider(huaweiCase) {
    this.api.assistanceApp.registerHuaweiCase(huaweiCase).promise().then(resp =>{
      this.done.emit(true);
    })
  }

  validateRol(roles, rol){
    let roles_list = new Set(roles)
    return roles_list.has(rol);
  }

}
